import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_claim_3_manual_adj",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "claim_3_manual_adj",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_claim_3_manual_adj_button",
  "data-kt-drawer-close": "#kt_drawer_claim_3_manual_adj_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_claim_3_manual_adj",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light rounded-0\" id=\"kt_claim_3_manual_adj_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Manual Adjustment Panel </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_claim_3_manual_adj_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_claim_3_manual_adj_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_claim_3_manual_adj_body",
  "data-kt-scroll-dependencies": "#kt_claim_3_manual_adj_header, #kt_claim_3_manual_adj_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = { class: "card mb-5 mb-xl-10 border-secondary rounded-0" }
const _hoisted_8 = {
  class: "card-header border-0 cursor-pointer bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#claim_3_manual_adj_form_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_9 = { class: "card-title m-0" }
const _hoisted_10 = { class: "fw-bolder m-0 text-dark" }
const _hoisted_11 = {
  id: "claim_3_manual_adj_form_data",
  class: "collapse show"
}
const _hoisted_12 = { class: "collapse show" }
const _hoisted_13 = { class: "card-body border-top p-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "How to adjust with current net payable?", -1)
const _hoisted_17 = { class: "row m-0" }
const _hoisted_18 = { class: "form-check col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault1"
}, " (+) Add ", -1)
const _hoisted_20 = { class: "form-check col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault2"
}, " (-) Reduce ", -1)
const _hoisted_22 = { class: "col-md-12 mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Manual Adjustment Date", -1)
const _hoisted_24 = { class: "col-md-12 mt-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Manual Adjustment Amount", -1)
const _hoisted_26 = { class: "col-md-12 mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill Amount", -1)
const _hoisted_28 = { class: "col-md-12 mt-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Adjusted Payable Amount", -1)
const _hoisted_30 = { class: "col-md-12 mt-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Remarks", -1)
const _hoisted_32 = {
  class: "card-footer py-5 text-center",
  id: "kt_claim_3_manual_adj_footer"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_claim_3_manual_adj_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_34 = ["data-kt-indicator"]
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", _hoisted_10, " Adjust Bill (" + _toDisplayString(_ctx.formData.bill_no) + ") ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "adjust_type",
                                  value: "add",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adjust_type) = $event)),
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.adjustType && _ctx.adjustType(...args)))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.adjust_type]
                                ]),
                                _hoisted_19
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "adjust_type",
                                  value: "reduce",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adjust_type) = $event)),
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.adjustType && _ctx.adjustType(...args)))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.adjust_type]
                                ]),
                                _hoisted_21
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createVNode(_component_el_form_item, {
                              prop: "manual_adjustment_date",
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.formData.manual_adjustment_date,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.manual_adjustment_date) = $event)),
                                  "value-format": "YYYY-MM-DD",
                                  format: "DD-MM-YYYY",
                                  style: {"width":"100%"},
                                  type: "date",
                                  name: "dob"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "manual_adjustment_date",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.formData.manual_adjustment_amount,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.manual_adjustment_amount) = $event)),
                              onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adjustBillCaluculate())),
                              name: "manual_adjustment_amount",
                              class: "form-control"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "manual_adjustment_amount",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.bill_amount,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bill_amount) = $event)),
                              name: "net_amount",
                              class: "form-control",
                              readonly: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "net_amount",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.formData.bill_amount_after_manual_adjustment,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.bill_amount_after_manual_adjustment) = $event)),
                              name: "bill_amount_after_manual_adjustment",
                              class: "form-control",
                              readonly: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "bill_amount_after_manual_adjustment",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.formData.remarks,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.remarks) = $event)),
                              name: "remarks",
                              class: "form-control"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "remarks",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_36, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_38
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_34)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ]))
}